import {StyledScrollbar, StyledScrollbarThumb} from 'src/components/scrollbar/style.ts'
import {ScrollAreaScrollbarProps} from '@radix-ui/react-scroll-area'
import {FC} from 'react'

export const Scrollbar: FC<ScrollAreaScrollbarProps> = props => {
    return (
        <StyledScrollbar {...props}>
            <StyledScrollbarThumb />
        </StyledScrollbar>
    )
}
